import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import SmoothScroll from 'smooth-scroll';

let scroll =  new SmoothScroll();

class ScrollToTop extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      const nextBase = this.props.location.pathname.split('/')[1];
      const previousBase = prevProps.location.pathname.split('/')[1];
      // don't scroll if it is same base path
      if (nextBase === previousBase) return;
      scroll.animateScroll(0);
    }
  }

  render() {
    return null;
  }
}

ScrollToTop.propTypes = {
  location: PropTypes.object
};

export default withRouter(ScrollToTop);

export {
  scroll
};
